/**
 * Toggle Current Navi Item
 *
 * 表示中のコンテンツに対応したナビゲーションの切り替え
 * @param {string} [activeClass='current'] - ナビゲーションに追加するクラス名
 */
export function toggleCurrentNavItem(activeClass = 'current') {
	// data-navi-content属性があるコンテンツを取得
	const naviContents = document.querySelectorAll('[data-navi-content]');

	if (naviContents.length) {
		window.addEventListener('scroll', () => {
			naviContents.forEach(naviContent => {
				// data-navi-contentの値を取得
				const naviDataId = naviContent.dataset.naviContent;
				// ナビゲーション内で同じ値をdata-navi-itemで指定しているアイテムを取得
				const naviItem = document.querySelector('[data-navi-item="' + naviDataId + '"]');
				// コンテンツのスクロール位置を取得
				const naviContentPosition = naviContent.getBoundingClientRect();

				// コンテンツが表示されている間のみclassにcurrentを追加
				if (naviItem && naviContentPosition.top < 0 && naviContentPosition.bottom > 0) {
					naviItem.classList.add(activeClass);
				} else {
					naviItem.classList.remove(activeClass);
				}
			});
		});
	}

}
